<template>
    <div>
          

    <v-navigation-drawer  v-model="drawer"
      :permanent="isLarge"
      style="background-color:#eee" 
      app
    >
      <v-card
        outlined
        width="344"
        height="240"
        color="grey lighten-3"
        class="pa-md-4 mx-lg-auto"
    >
       <v-list-item-content class="mt-3">
        <v-img src="./static/tmp-logo.jpg" class="ma-3" max-width="200px" contain></v-img>
        <v-list-item-title class="ma-3">{{profile.Name}}</v-list-item-title>
      </v-list-item-content>

      <v-card-actions>
        <v-btn v-show="userProfile"  class="ml-8" style="width:150px" color='green' dark  @click="signOut()">注销</v-btn>
      </v-card-actions> 
    </v-card>
      <v-divider></v-divider>
        <v-list 
        shaped
        >
        <v-list-item-group
          active-class="deep-blue--text text--accent-4"
          class="ml-3"
        >
        
          <v-list-item @click="go('/',false)">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-title>开始预定</v-list-item-title>
          </v-list-item>
          <v-list-item @click="go('RB')">
            <v-list-item-icon>
              <v-icon>mdi-calendar-week</v-icon>
            </v-list-item-icon>
            <v-list-item-title>我的预定</v-list-item-title>
          </v-list-item>
          <v-list-item @click="go('/userProfile')">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>用户信息</v-list-item-title>
          </v-list-item>
        <!--  <v-list-item @click="go('/management/bookingtype')">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>系统管理</v-list-item-title>
          </v-list-item>-->
          <v-divider></v-divider>
     <!--   <v-list-item v-if="isApprover" @click="go('/adminPage')">
            <v-list-item-icon>
              <v-icon>mdi-table-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>批量审批</v-list-item-title>
          </v-list-item>
           <v-list-item v-if="isAdmin()" @click="go('/role')">
            <v-list-item-icon>
              <v-icon>mdi-table-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>角色管理</v-list-item-title>
          </v-list-item>-->
          <v-list-item v-if="isAdmin()" @click="go('/report')">
            <v-list-item-icon>
              <v-icon>mdi-table-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>查看报表</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isAdmin()" @click="go('/eventTemplate')">
            <v-list-item-icon>
              <v-icon>mdi-table-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>管理预定模板</v-list-item-title>
          </v-list-item>
            <v-list-item v-if="isAdmin()" @click="go('/eventSlotPattern')">
            <v-list-item-icon>
              <v-icon>mdi-table-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>管理时间槽</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>

    </v-navigation-drawer>

  <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>中山大学资源预约平台</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { baseService } from "@/api/base-service";
import {EventBus} from '@/plugins/event-bus';

export default {
    name:'navibar',
    data: () => ({
      drawer: false,
      profile: {Name: '未登录'},
      isApprover: false
    }),
    computed: {
      ...mapGetters(["userProfile"]),
      isLarge() {
        return this.$vuetify.breakpoint.name !== 'xs'
        },
      showDrawer: {
        get: function(){
        return (this.isLarge || this.drawer);
        },
        set: function(){
          this.drawer = !this.drawer;
        } 
      }   
    },
    methods: {
    go (url, drawer = true) {
     // console.log(this.$route.path)
      this.drawer = drawer
      if (url==="RB") window.open(process.env.VUE_APP_RBURL);
      if (url !== this.$route.path) this.$router.push(url)
    },
    signOut(){
      localStorage.clear();
      window.location.href = process.env.VUE_APP_SIGNOUT;
    },
    isAdmin(){
      if (!this.profile.Roles) return false;
      return this.profile.Roles.findIndex(x=>x==='template owner' || x==='institution admin')!=-1;
    }
  },
  async mounted(){
      if (!this.userProfile)
      {
        await this.$store.dispatch('getUserProfile');
        this.profile = this.userProfile;
        //if (this.$route.path !== '/') this.$router.push('/')
      }
      let _notifs = await baseService.getNotifications();
      if (_notifs != null && _notifs.Count > 0) this.isApprover = true 
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Nav/NaviBar.vue